import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "./hrmsNotifications";
import Apis from "../../utils/apis";

export const userReminderApi = createApi({
  reducerPath: "userReminder",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["UserReminder"],
  endpoints: (builder) => ({
    getUnreadReminders: builder.query({
      query: () => ({
        url: Apis.getUnreadReminders,
      }),
      providesTags: ["UserReminder"],
      // keepUnusedDataFor: 0,
      pollingInterval: 5 * 60 * 1000,
    }),

    markReminderAsRead: builder.mutation({
      query: (reminderId) => ({
        url: `${Apis.markReminderAsRead}/read/${reminderId}`,
        method: "POST",
      }),
      invalidatesTags: ["UserReminder"],
    }),
  }),
});

export const { useGetUnreadRemindersQuery, useMarkReminderAsReadMutation } =
  userReminderApi;
